import { __ } from '@wordpress/i18n';
import domReady from '@wordpress/dom-ready';

function showMoreButtons(el) {
	const buttons = el.querySelector('.b-collapsed-buttons');
	const toggleEl = el.querySelector('.b-collapsed-buttons__toggle');
	const toggleElInner = toggleEl?.querySelector('span');

	const toggleElClass = 'b-collapsed-buttons__toggle';
	const toggleElActiveClass = 'b-collapsed-buttons__toggle--active';
	const buttonsAllClass = 'b-collapsed-buttons--all';

	if (!toggleElInner) {
		return;
	}

	el.addEventListener('click', (e) => {
		if ((e.target).classList.contains(toggleElClass) || (e.target).parentElement?.classList.contains(toggleElClass)) {
			toggleEl?.classList.toggle(toggleElActiveClass);

			if (buttons?.classList.contains(buttonsAllClass)) {
				buttons.classList.remove(buttonsAllClass);
				toggleElInner.innerHTML = __('More', 'dt-blocks'); // phpcs:ignore WordPressVIPMinimum.JS.InnerHTML.Found
			} else {
				buttons?.classList.add(buttonsAllClass);
				toggleElInner.innerHTML = __('Less', 'dt-blocks'); // phpcs:ignore WordPressVIPMinimum.JS.InnerHTML.Found
			}
		}
	});
}

function productsListToggle(item) {
	const list = item.querySelector('.dtb-product-index__list');
	const listModifier = 'dtb-product-index__list--long';
	const btn = item.querySelector('.dtb-product-index__button');
	const additionalBtnClass = 'dtb-product-index__button--active';

	if (btn) {
		btn.addEventListener('click', () => {
			if (!btn.dataset.text?.length) {
				btn.dataset.text = btn.innerText;
			}
			if (list?.classList.contains(listModifier)) {
				list.classList.remove(listModifier);
				btn.classList.remove(additionalBtnClass);
				btn.innerHTML = btn.dataset.text || __('Show More', 'dt-blocks'); // phpcs:ignore WordPressVIPMinimum.JS.InnerHTML.Found
			} else {
				btn.innerHTML = __('Show Less', 'dt-blocks'); // phpcs:ignore WordPressVIPMinimum.JS.InnerHTML.Found
				btn.classList.add(additionalBtnClass);
				list?.classList.add(listModifier);
			}
		});
	}
}

function init() {
	const initCompact = (el) => {
		if (el.dataset.buttonsInitialized) {
			return;
		}
		showMoreButtons(el);
		el.dataset.buttonsInitialized = 'true';
	};

	const initProductIndex = (el) => {
		if (el.dataset.productIndexInitialized) {
			return;
		}
		productsListToggle(el);
		el.dataset.productIndexInitialized = 'true';
	};

	document.querySelectorAll('.dtb-compact').forEach(initCompact);
	document.querySelectorAll('.dtb-product-index').forEach(initProductIndex);

	const observer = new MutationObserver((mutationsList) => {
		mutationsList.forEach((mutation) => {
			mutation.addedNodes.forEach((node) => {
				if (!(node instanceof HTMLElement)) {
					return;
				}

				if (node.matches('.dtb-compact')) {
					initCompact(node);
				}
				node.querySelectorAll('.dtb-compact').forEach(initCompact);

				if (node.matches('.dtb-product-index')) {
					initProductIndex(node);
				}
				node.querySelectorAll('.dtb-product-index').forEach(initProductIndex);
			});
		});
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true,
	});
}

domReady(init);
